export default __webpack_public_path__ + "static/media/box-logo.21ffb51c.png";